<template>
    <el-dialog
      :visible.sync="showSpace"
      title="编辑空间信息"
      width="440px"
      @close="closeDialog"
      :close-on-click-modal="false"
      custom-class="space-dialog"
      :append-to-body="true"
    >
      <el-form
        ref="dialogForm"
        :model="dialogInfo"
        label-width="82px"
        label-position="left"
        :rules="rules"
      >
        <el-form-item label="空间名称:" prop="name">
          <el-input
            v-model.trim="dialogInfo.name"
            placeholder="请输入"
            :maxlength="60"
            style="width: 300px"
          />
        </el-form-item>
        <el-form-item class="cover" label="封面:" prop="cover">
          <div class="gou-upload">
            <div
              v-if="!shopLogoUrl"
              class="gou-upload-logo gou-reupload-item-image"
              @click="() => mutateLogo()"
            >
              <img
                v-if="coverUrl"
                class="space-avstar"
                :src="$hosts.static(coverUrl)"
                alt=""
              />
              <img
                v-else
                class="space-avstar"
                :src="require('@/assets/img/spaceBg.png')"
                alt=""
              />
              <gou-pick-file
                :filters="imgFilters"
                :multiple="false"
                :max-file-size="2"
                @event-pick-file="(data) => mutateLogo(data.file)"
              >
                <div class="gou-upload-item-image-operate">重新上传</div>
              </gou-pick-file>
            </div>
            <div v-else class="gou-reupload-item-image">
              <img id="showLogoImg" :src="shopLogoUrl" alt="" />
              <gou-pick-file
                :filters="imgFilters"
                :multiple="false"
                :max-file-size="2"
                @event-pick-file="(data) => mutateLogo(data.file)"
              >
                <div class="gou-upload-item-image-operate">重新上传</div>
              </gou-pick-file>
            </div>
          </div>
          <span class="img-msg"> 支持2MB以下, jpg/png </span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="footer">
        <slot name="customFooter">
          <el-button @click="closeDialog">取消</el-button>
          <el-button
            type="primary"
            :loading="confirmLoading"
            @click="confirmDialog"
            >确定</el-button
          >
        </slot>
      </div>
    </el-dialog>
  </template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { updateTeamSpacesErrorCodeMap } from './errorCodeMap'
import GouPickFile from '@/components/gou/GouPickFile'
export default {
  name: 'EditSpace',
  components: {
    GouPickFile
  },
  data() {
    return {
      spaceId: '',
      name: '',
      coverUrl: '',
      confirmLoading: false,
      showSpace: false,
      shopLogoUrl: '',
      shopUrl: '',
      imgFilters: '.jpg,.png',
      dialogInfo: {
        name: '',
      },
      dialogForm: {},
      rules: {
        name: [
          { required: true, message: '请输入空间名称', trigger: 'blur' },
          { validator: this.customValidate, trigger: 'blur' }
        ],
      },
      activeApiCode: ''
    }
  },
  computed: {
    ...mapGetters({
      spacesDetail: 'classifySpace/spacesDetail',
    }),
  },
  created() {
  },
  mounted() {},
  methods: {
    ...mapActions({
      getSpacesDetail: 'classifySpace/getSpacesDetail',
    }),
    async openDialog(spaceId) {
      this.spaceId = spaceId
      if (this.spaceId) {
        await this.getSpacesDetail(this.spaceId)
        this.dialogInfo = {
          name: this.spacesDetail.name
        }
        this.coverUrl = this.spacesDetail.coverUrl || ''
        this.showSpace = true
      }
    },
    confirmDialog() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          const formData = new FormData()
          formData.append('id', this.spaceId)
          formData.append('name', this.dialogInfo.name)
          formData.append('cover', this.shopUrl || this.$hosts.static(this.coverUrl))
          this.$api.space.editTeamSpaces(this.spaceId, formData).then(async (res) => {
            this.showSpace = false
            this.$tracks({ event: 'modifySpace', params: { g_c_space_id: this.spaceId }})
            await this.getSpacesDetail(this.spaceId)
            this.$emit('modify-success', this.spacesDetail)
            this.$message.success(`编辑成功`)
          }).catch((err) => {
            this.activeApiCode = err.code
            this.$refs.dialogForm.validateField('name')
          })
        }
      })
    },
    // 新建-重名校验
    customValidate(rule, value, callback) {
      let errorFound = false
      for (const key in updateTeamSpacesErrorCodeMap) {
        if (Object.prototype.hasOwnProperty.call(updateTeamSpacesErrorCodeMap, key)) {
          if (this.activeApiCode === key) {
            this.activeApiCode = ''
            callback(new Error(updateTeamSpacesErrorCodeMap[key]))
            errorFound = true
            break
          }
        }
      }
      if (!errorFound) {
        callback()
      }
    },
    async mutateLogo(file) {
      if (file === undefined) {
        file = await this.$file.pickFile({
          filters: this.imgFilters,
        })
        await this.mutateLogo(file)
      } else {
        this.shopUrl = file
        // 创建 一个FileReader对象
        var reader = new FileReader()
        console.log(reader)
        reader.onload = (e) => {
          console.log(e)
          this.shopLogoUrl = e.target.result
        }
        // 读取文件作为URL可访问地址
        reader.readAsDataURL(file)
      }
    },
    closeDialog() {
      this.showSpace = false
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  display: flex;
  .container {
    flex: 1;
  }
}
.content-box {
  padding: 16px 0 0 16px;
}
.item-block {
  display: table;
  margin-bottom: 16px;
  .block-left {
    width: 75px;
    display: inline-flex;
  }
  .line-item {
    display: inline-block;
    width: 498px;
    border-bottom: 1px solid #d2d9e3;
  }
}
.whiteBg {
  border: 1px solid #d2d9e3;
  background: #fff;
  color: #495f70;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
  border-bottom: 1px solid #d2d9e3;
  padding: 8px 16px;
  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  span {
    font-family: Microsoft YaHei;
    font-size: 20px;
    font-weight: normal;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0em;
    color: #495f70;
  }
}
.item-block {
  img {
    border: 1px solid #d2d9e3;
    width: 400px;
    height: 225px;
    border-radius: 2px;
  }
  .spaceBg {
    position: relative;
    display: inline-block;
    top: -212px;
    left: 0;
  }
}
/deep/ .el-dialog__body {
  padding-bottom: 0;
  border-bottom: 1px solid #d2d9e3 !important;
}
/deep/ .el-form-item__label:not(required)::before {
  content: "*";
  color: transparent;
  margin-right: 4px;
}
.gou-upload {
  display: flex;
  align-items: flex-end;
  .gou-upload-item-image {
    width: 300px;
    height: 156px;
    background: rgba(225, 225, 235, 1);
    margin-left: 32px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .gou-upload-item-image-operate {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 300px;
      background: rgba(35, 40, 50, 1);
      opacity: 0.5;
      text-align: center;
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
      padding: 4px 0;
    }
  }
  .gou-reupload-item-image {
    width: 300px;
    height: 156px;
    background: rgba(225, 225, 235, 1);
    position: relative;
    text-align: center;
    & > img {
      width: 300px;
      height: 156px;
    }
    .gou-upload-item-image-operate {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 300px;
      background: rgba(35, 40, 50, 1);
      opacity: 0.5;
      text-align: center;
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
      padding: 4px 0;
      & :hover {
        color: #39e9db;
      }
    }
  }
  .gou-upload-logo {
    border: 1px dashed #d2d9e3;
    cursor: pointer;
    width: 300px;
    height: 156px;
    background-color: #fafafa;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    span {
      line-height: 10px;
    }
    .icon-icon_add {
      font-size: 12px;
      &::before {
        border: 2px solid rgba(76, 84, 114, 1);
        border-radius: 50%;
        padding: 2px;
      }
    }
  }
  .gou-upload-tips {
    margin-left: 16px;
  }
}
.img-msg {
  font-size: 12px;
  color: #495f70;
}
img {
  width: 300px;
  height: 156px;
}
</style>
